import { useEffect } from 'react';
import { State, useStore } from 'store';

import fetchDashboardRuns, { IDashboardRunsParams } from 'store/fetchDashboardRuns';

import IAsync from 'types/IAsync';
import IPaginatedResponse from 'types/IPaginatedResponse';
import IRunEntry from 'types/IRunEntry';

const POLL_INTERVAL_MS = 15000;

export default function useAutofetchedDashboardRunsAsync(
  params: IDashboardRunsParams = {},
): IAsync<IPaginatedResponse<IRunEntry>> {
  const runsAsync = useStore((state: State) => state.dashboard.runsAsync);

  const { page, pageSize, search, userId, hasRunningTasks, sort, order } = params;
  const projectIdsKey = (params.projectIds ?? []).join(',');

  useEffect(() => {
    const fetchParams: IDashboardRunsParams = {
      page,
      pageSize,
      search,
      projectIds: projectIdsKey ? projectIdsKey.split(',') : undefined,
      userId,
      hasRunningTasks,
      sort,
      order,
    };
    fetchDashboardRuns(fetchParams);
    const intervalId = setInterval(() => fetchDashboardRuns(fetchParams), POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [page, pageSize, search, projectIdsKey, userId, hasRunningTasks, sort, order]);

  return runsAsync;
}
